import useSWR from 'swr'
import fetch from 'unfetch'
import getConfig from 'next/config'

const config = getConfig().publicRuntimeConfig

const useGetCampaignsData = (campaignIds) => { 
    const apiUrl = `search?fq=type:campaign&fq=id:(${encodeURIComponent(campaignIds.join(' '))})&rows=${campaignIds.length}`;
    const { data: campaigns, error } = useSWR(apiUrl, (url, ...args) => {
        url = 'https://fundraisers.giveindia.org/' + url;
        //config.fundraisersPlatformUrl + url;
        return fetch(url, ...args).then(res => res.json()).then(res => res.response.docs);
    }, { refreshInterval: 60000 });   

    return {
        campaigns,
        error
    }
}

export default useGetCampaignsData;